var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 18.7617C7.75 18.3475 8.08579 18.0117 8.5 18.0117H20.5006C20.9149 18.0117 21.2506 18.3475 21.2506 18.7617C21.2506 19.1759 20.9149 19.5117 20.5006 19.5117H8.5C8.08579 19.5117 7.75 19.1759 7.75 18.7617Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 12.7617C7.75 12.3475 8.08579 12.0117 8.5 12.0117H20.5006C20.9149 12.0117 21.2506 12.3475 21.2506 12.7617C21.2506 13.1759 20.9149 13.5117 20.5006 13.5117H8.5C8.08579 13.5117 7.75 13.1759 7.75 12.7617Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 6.76172C7.75 6.34751 8.08579 6.01172 8.5 6.01172H20.5006C20.9149 6.01172 21.2506 6.34751 21.2506 6.76172C21.2506 7.17593 20.9149 7.51172 20.5006 7.51172H8.5C8.08579 7.51172 7.75 7.17593 7.75 6.76172Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6.76076C3.5 6.20277 3.95224 5.75 4.5107 5.75C5.06858 5.75 5.52156 6.20218 5.52156 6.76076C5.52156 7.31935 5.06858 7.77153 4.5107 7.77153C3.95223 7.77153 3.5 7.31875 3.5 6.76076Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12.8897C3.5 12.3317 3.95224 11.8789 4.5107 11.8789C5.06858 11.8789 5.52156 12.3311 5.52156 12.8897C5.52156 13.4483 5.06858 13.9004 4.5107 13.9004C3.95223 13.9004 3.5 13.4477 3.5 12.8897Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 18.7608C3.5 18.2028 3.95224 17.75 4.5107 17.75C5.06858 17.75 5.52156 18.2022 5.52156 18.7608C5.52156 19.3193 5.06858 19.7715 4.5107 19.7715C3.95223 19.7715 3.5 19.3188 3.5 18.7608Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutNews);
export default __webpack_public_path__ + "static/media/about_news.e2becd1bfd5d4974950a3d5376251da6.svg";
export { ForwardRef as ReactComponent };